import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertCircle, XCircle, DollarSign } from 'lucide-react';
export function PainSection() {
  return <section className="py-20 md:py-32 bg-cream-100 relative overflow-hidden" data-id="element-133">
      <div className="max-w-3xl mx-auto px-6 relative z-10" data-id="element-134">
        <FadeIn data-id="element-135">
          <h2 className="text-3xl md:text-5xl font-serif text-brown-900 mb-12 text-center leading-tight" data-id="element-136">
            Esto es lo que nadie te dice <br data-id="element-137" />
            <span className="italic text-rose-muted text-2xl md:text-4xl" data-id="element-138">
              (y tú ya lo sospechas)
            </span>
          </h2>
        </FadeIn>

        <div className="space-y-8 text-lg md:text-xl text-brown-800 leading-relaxed font-sans" data-id="element-139">
          <FadeIn delay={0.15} data-id="element-140">
            <p data-id="element-141">No estás "fallando" en el cuidado del cabello.</p>
            <p className="font-medium text-brown-900" data-id="element-142">
              Estás usando una rutina que:
            </p>
          </FadeIn>

          <FadeIn delay={0.25} data-id="element-143">
            <ul className="space-y-4 my-8 bg-white/50 p-8 rounded-2xl border border-brown-900/5" data-id="element-144">
              {['no es para tu textura', 'no respeta tu tiempo', 'y no se ajusta al clima donde vives'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-145">
                  <XCircle className="w-6 h-6 text-rose-muted shrink-0 mt-1" data-id="element-146" />
                  <span data-id="element-147">{item}</span>
                </li>)}
            </ul>
          </FadeIn>

          <FadeIn delay={0.35} data-id="element-148">
            <p data-id="element-149">
              Entonces pasa lo típico: un día te queda bonito… y al siguiente,
              frizz. Te miras al espejo y sientes que <em data-id="element-150">tú</em> estás mal, no
              solo tu pelo.
            </p>
            <p className="mt-4" data-id="element-151">
              Y tú no sabes si fue el champú, el leave‑in, la crema, el gel, la
              humedad, tu técnica, tu toalla, tu almohada… o tu paciencia.
            </p>
          </FadeIn>

          <FadeIn delay={0.45} data-id="element-152">
            <div className="bg-rose-muted/10 p-8 rounded-2xl border border-rose-muted/20 mt-4" data-id="element-153">
              <p className="font-serif text-2xl text-brown-900 italic mb-4 leading-snug" data-id="element-154">
                "Hago cosas… compro cosas… y mi pelo igual amanece distinto. Me
                siento engañada y me da vergüenza."
              </p>
              <p className="text-brown-800/70 text-base" data-id="element-155">
                — Si esto te suena familiar, no estás sola. Y no es tu culpa.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.55} className="bg-white p-8 rounded-2xl shadow-sm border-l-4 border-terracotta mt-4" data-id="element-156">
            <div className="flex gap-4" data-id="element-157">
              <AlertCircle className="w-6 h-6 text-terracotta shrink-0 mt-1" data-id="element-158" />
              <div data-id="element-159">
                <p className="font-serif italic text-xl text-brown-900 mb-4" data-id="element-160">
                  Y ahí llega la compra impulsiva:
                </p>
                <div className="space-y-2 text-brown-800/80" data-id="element-161">
                  <p data-id="element-162">"Este sí."</p>
                  <p data-id="element-163">"Este es el que me falta."</p>
                  <p data-id="element-164">"Este es el milagro."</p>
                </div>
                <p className="mt-6 font-medium text-brown-900" data-id="element-165">
                  Hasta que tienes una colección completa de promesas… y cero
                  sistema.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.65} data-id="element-166">
            <div className="flex gap-4 bg-white p-8 rounded-2xl shadow-sm border-l-4 border-brown-900/30 mt-4" data-id="element-167">
              <DollarSign className="w-6 h-6 text-brown-900/60 shrink-0 mt-1" data-id="element-168" />
              <div data-id="element-169">
                <p className="font-medium text-brown-900 mb-3" data-id="element-170">
                  Haz la cuenta:
                </p>
                <p className="text-brown-800/80" data-id="element-171">
                  Cada producto que "no funcionó" te costó entre $12 y $35.
                  Multiplica eso por todos los que tienes en el baño acumulando
                  polvo.
                </p>
                <p className="mt-4 text-brown-900 font-semibold text-xl" data-id="element-172">
                  ¿$50? ¿$100? ¿$200+?
                </p>
                <p className="mt-2 text-brown-800/70" data-id="element-173">
                  Todo ese dinero… y sigues sin saber qué hacer mañana por la
                  mañana.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.75} data-id="element-174">
            <p className="text-center text-xl font-serif italic text-brown-900 mt-8" data-id="element-175">
              El problema no eres tú. El problema es que nadie te ha dado{' '}
              <span className="underline decoration-terracotta decoration-2 underline-offset-4" data-id="element-176">
                un mapa claro
              </span>
              .
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}